<div class="clearfix pt-2">
  <p class="pl-2 text-right"> <span class="pr-2"> {{ username }} </span> | <span class="underline pl-2"> <a href="#"
        (click)="logout()" class="logout-ui "> Logout </a> </span></p>
</div>

<nav class="row navbar navbar-expand-lg navbar-light border-set">
  <a class="navbar-brand" href="#"> <img alt="Logo" src="assets/images/logo.png" width="120px" /> </a>
  <ul class="navbar-nav mr-auto ">

    <li class="nav-item   d-lg-none d-md-none d-sm-block d-xs-block " style="width: 100%;">
      <h3 class="ch-name"><b> </b> {{ merchantname }} </h3>
      <p class="large roboto-reg"> {{ this.merchantAddressLineOne}}</p>
      <p class="roboto-reg"> {{ this.merchantAddressLineTwo}}</p>
    </li>

  </ul>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse " id="navbarSupportedContent">
    <div class="d-none d-sm-block  ">
      <ul class="navbar-nav mr-auto ">
        <li class="nav-item active">
          <img class="pt-2 pr-3" alt="Logo" src="{{   this.imageurl }}" width="100%" />
        </li>
        <li class="nav-item" style="width: 300px;">
          <h3 class="ch-name"><b> </b> {{ merchantname }} </h3>
          <p class="large roboto-reg"> {{ this.merchantAddressLineOne}}</p>
          <p class="roboto-reg"> {{ this.merchantAddressLineTwo}}</p>
        </li>

      </ul>
    </div>
    <div class="text-right d-flex flex-row-reverse" style="width: 100%;">
      <ul class="form-inline  menu-list my-2 my-lg-0 pl-0  header-rew">
        <li class=" form-inline  "> <a href="" class="pt-2 pb-2 pl-4 {{ this.billing == true   ? 'active' : '' }}   ">
            Billing </a> </li>
        <li class=" form-inline  "> <a href="merchant/order/list"
            class="pt-2 pb-2 pl-4 {{ this.order == true   ? 'active' : '' }} "> Orders </a> </li>
        <li class=" form-inline  "> <a href="merchant/finance/list"
            class="pt-2 pb-2 pl-4 {{ this.finance == true   ? 'active' : '' }} "> Finance </a></li>
      </ul>
    </div>
  </div>




</nav>